import PropTypes from 'prop-types'

import { Box, Typography, IconButton } from '@mui/material'
import Loader from '../../../ui/views/Loader'

import { ReactComponent as X } from '../../../assets/icons/x.svg'

import styles from './styles'

const MobileFullScreen = ({ isLoading, title, children, onClose }) => {
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Box sx={styles.root}>
          <>
            {title ? (
              <Box sx={styles.header}>
                <Typography variant="h2">{title}</Typography>
                <IconButton onClick={onClose} sx={styles.closeButton}>
                  <X />
                </IconButton>
              </Box>
            ) : null}
            {children}
          </>
        </Box>
      )}
    </>
  )
}

MobileFullScreen.propTypes = {
  isLoading: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
}

export default MobileFullScreen
